import type { FC } from "react";
import React, { memo, useCallback, useEffect } from "react";
import { useControls } from "react-zoom-pan-pinch";
import { Button } from "@material-ui/core";

import "./styles.scss";

type Props = {
    isFullscreen: boolean;
};

const ImageControlsFC: FC<Props> = ({ isFullscreen }: Props) => {
    const { zoomIn, zoomOut, resetTransform } = useControls();
    const handleZoomIn = useCallback(() => zoomIn(), [zoomIn]);
    const handleZoomOut = useCallback(() => zoomOut(), [zoomOut]);
    const handleReset = useCallback(() => resetTransform(), [resetTransform]);

    useEffect(() => {
        resetTransform();
    }, [isFullscreen]);

    return isFullscreen ? (
        <div className="unit__image-controls">
            <Button
                className="unit__image-controls__button"
                color="secondary"
                onClick={handleZoomIn}
                size="large"
                variant="contained"
            >
                +
            </Button>
            <Button
                className="unit__image-controls__button"
                color="primary"
                onClick={handleZoomOut}
                size="large"
                variant="contained"
            >
                -
            </Button>
            <Button
                className="unit__image-controls__button unit__image-controls__button--reset"
                color="primary"
                onClick={handleReset}
                size="large"
                variant="contained"
            >
                ✕
            </Button>
        </div>
    ) : null;
};

export const ImageControls = memo(ImageControlsFC);
